import { IconPromptTag } from '@/assets';
import type { NftMarket } from '@/types';

import MarketPlaceCard from '../../MarketPlaceCard';

const ListMarket: React.FC<{
  nftMarketList: NftMarket[];
  openFilter: boolean;
}> = ({ nftMarketList, openFilter }) => {
  return (
    <div className="-mx-[20px] flex flex-wrap">
      {nftMarketList.map((nftMarket, index) => {
        return (
          <div
            aria-expanded={openFilter}
            key={index}
            className="relative mb-[20px] w-[calc(100%/6)] px-[10px] aria-expanded:w-[calc(100%/5)] 3xl:w-[calc(100%/5)] aria-expanded:3xl:w-[calc(100%/4)] xl:w-[calc(100%/4)] aria-expanded:xl:w-[calc(100%/3)] lg:w-[calc(100%/3)] aria-expanded:lg:w-[calc(100%/2)] md:w-[calc(100%/2)] sm:!w-full"
          >
            {nftMarket.asset.prompt !== null && (
              <div className="pointer-events-none absolute left-[2px] top-[-5px] z-30">
                <IconPromptTag />
              </div>
            )}
            <MarketPlaceCard nftMarket={nftMarket} />
          </div>
        );
      })}
    </div>
  );
};

export default ListMarket;
